import React, { useState } from 'react';
import { LockIcon } from 'lucide-react';
interface PasswordGateProps {
  onAuthenticate: (password: string) => void;
}
export function PasswordGate({
  onAuthenticate
}: PasswordGateProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onAuthenticate(password);
      setError(true);
      setPassword('');
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4" data-id="element-102">
      <div className="max-w-md w-full" data-id="element-103">
        <div className="text-center mb-8" data-id="element-104">
          <div className="flex justify-center mb-4" data-id="element-105">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nHh5FC22HMTcqGd6hdU9hd/LegalLama_Icon_Logo_458-458.png" alt="LegalLama Logo" className="h-20 w-auto" data-id="element-106" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-107">Legallama</h1>
          <p className="text-gray-600" data-id="element-108">
            Bitte geben Sie das Passwort ein, um fortzufahren
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200" data-id="element-109">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-110">
            <div data-id="element-111">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-112">
                Passwort
              </label>
              <div className="relative" data-id="element-113">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-114">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-115" />
                </div>
                <input type="password" id="password" value={password} onChange={e => {
                setPassword(e.target.value);
                setError(false);
              }} className={`block w-full pl-10 pr-3 py-3 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors`} placeholder="Passwort eingeben" autoFocus data-id="element-116" />
              </div>
              {error && <p className="mt-2 text-sm text-red-600" data-id="element-117">
                  Falsches Passwort. Bitte versuchen Sie es erneut.
                </p>}
            </div>

            <button type="submit" className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-118">
              Zugang anfordern
            </button>
          </form>
        </div>

        <p className="text-center text-sm text-gray-500 mt-6" data-id="element-119">
          Geschützte Seite – Zugang nur mit gültigem Passwort
        </p>
      </div>
    </div>;
}